import { render, staticRenderFns } from "./BuildingAddServiceModal.vue?vue&type=template&id=468bbc5d&"
import script from "./BuildingAddServiceModal.vue?vue&type=script&lang=ts&"
export * from "./BuildingAddServiceModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chuongdev/Desktop/project/209web_admin-chung-cu/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('468bbc5d')) {
      api.createRecord('468bbc5d', component.options)
    } else {
      api.reload('468bbc5d', component.options)
    }
    module.hot.accept("./BuildingAddServiceModal.vue?vue&type=template&id=468bbc5d&", function () {
      api.rerender('468bbc5d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/building/components/BuildingAddServiceModal.vue"
export default component.exports